import React from 'react';

import { AGENT_MESSAGE_DIRECTION, IAgentMessage } from '../agent-sdk/message';
import { IMessage, Mode } from '../upchat-sdk/message';
import AgentBubbleContent from './AgentBubbleContent';
import BubbleContent from './BubbleContent';

export interface BubbleProps {
  message: IAgentMessage;
  showName?: boolean;
  showAvatar?: boolean;
  showBubbleBackground?: boolean;
  imageMaxWidth?: string;
  avatarSize?: string;
  fontSize?: string;
  split?: boolean;
  HiddenDelete?: boolean; // 是否隐藏被撤回的信息
  hiddenPlugins?: boolean;
  handleSubmitOpinion?: (
    data: Record<'score', number> & Record<'content', string | null>
  ) => any;
  handleSubmitUserInfo?: (data: string) => any;
  handleSubmitFeedback?: any;
  handleSubmitOfflineMsg?: any;
  handleSubmitAdvisoryType?: any;
}

function LeftBubble(
  props: BubbleProps & Record<'content', JSX.Element | string>
) {
  const bubbleClassName = props.showBubbleBackground
    ? 'flex rounded-md bg-gray-200 mx-2 text-lg text-gray-800'
    : 'flex text-lg text-gray-800';
  const extraClassName = '';
  const ref = React.createRef<HTMLDivElement>();

  return (
    <div className="mx-2 my-2">
      <div className="text-orange-500">
        {' '}
        {props.showName ? 'DeepSeek' : null}
      </div>
      <div className="flex">
        {props.showAvatar ? (
          <img
            style={{
              width: props.avatarSize,
              height: props.avatarSize,
              objectFit: 'contain',
            }}
            src={'/media/images/waiter.png'}
            alt=""
          />
        ) : null}
        <div className={bubbleClassName + ' ' + extraClassName} ref={ref}>
          {props.content}
        </div>
      </div>
    </div>
  );
}

function RightBubble(
  props: BubbleProps & Record<'content', JSX.Element | string>
) {
  const bubbleClassName = props.showBubbleBackground
    ? 'flex rounded-md text-lg bg-blue-500 mx-2 text-white'
    : 'flex text-lg text-gray-800';
  const extraClassName = '';

  const ref = React.createRef<HTMLDivElement>();
  return (
    <div className="mx-2 my-2">
      <div
        className={
          'text-green-500' + (props.split === false ? '' : ' text-right')
        }
      >
        {props.showName ? 'DeepSeek' : null}
      </div>
      <div
        className={'flex' + (props.split === false ? '' : ' flex-row-reverse')}
      >
        {props.showAvatar ? (
          <img
            style={{
              width: props.avatarSize,
              height: props.avatarSize,
              objectFit: 'contain',
            }}
            src={'/media/images/anonymou.png'}
            alt=""
          />
        ) : null}
        <div className={bubbleClassName + ' ' + extraClassName} ref={ref}>
          {props.content}
        </div>
      </div>
    </div>
  );
}

// Bubble 信息气泡显示
export default function AgentBubble(props: BubbleProps) {
  if (props.message.direction === AGENT_MESSAGE_DIRECTION.TO_ANONYMOUS) {
    return (
      <LeftBubble {...props} content={<AgentBubbleContent {...props} />} />
    );
  }

  return <RightBubble {...props} content={<AgentBubbleContent {...props} />} />;
}
